import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Dropdown from 'react-bootstrap/Dropdown';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage, useIntl } from 'react-intl';
import { makeStyles } from 'tss-react/mui';
import { toAbsoluteUrl } from '../..';
import HeaderDropdownToggle from '../content/CustomDropdowns/HeaderDropdownToggle';
import { useDefineUserRole } from '../../../app/hooks';
import { IAppState } from '../../../app/store/rootDuck';
import { setLocation } from '../../../app/store/ducks/yandexLocation.duck';
import { useModalCategory } from '../../layout/categories/categoryContext';

const useStyles = makeStyles()(theme => {
  return {
    headerBtn: {
      marginLeft: theme.spacing(1),
    },
    authText: {
      display: 'none',

      [theme.breakpoints.up('md')]: {
        display: 'block',
      },
    },
    cartText: {
      color: theme.palette.secondary.main,
      [theme.breakpoints.up('md')]: {
        maxWidth: 70,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
    },
    autoLoc: {
      width: '100%',
    },
    cartBtn: {
      marginRight: 0,
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
      height: 55,
      justifyContent: 'center',
      gap: 4,
      marginTop: 2,
    },
    chatBtn: {
      marginRight: 10,
      marginTop: 1,
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
      [theme.breakpoints.up('md')]: {
        marginRight: 20,
      },
    },
    cartBtnGuest: {
      marginRight: 0,
      marginTop: 1,
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
      height: 55,
      justifyContent: 'center',
      gap: 4,
      [theme.breakpoints.up('md')]: {
        marginRight: 30,
      },
    },
    cartBadge: {
      display: 'block',
      position: 'absolute',
      right: 17,
      width: 10,
      top: 5,
      height: 10,
      [theme.breakpoints.up('md')]: {
        transform: 'translateX(110%)',
      },
    },
    auth: {
      marginLeft: '20px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 4,
      height: 55,
      [theme.breakpoints.up('md')]: {
        marginLeft: 0,
      },
    },
    iconStandardized: {
      height: 25,
      width: 'auto',
      objectFit: 'contain',
    },
    profileAvatar: {
      // width: 25,
      width: 80,
      marginLeft: 15,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-evenly',
      height: 55,
      overflow: 'hidden',
      flexDirection: 'column',
      [theme.breakpoints.up('md')]: {
        marginLeft: 0,
        width: 80,
      },
    },
    background: {
      height: 'calc(100% - 65px) !important',
      bottom: 0,
      [theme.breakpoints.down('md')]: {
        height: 'calc(100% - 66px) !important',
      },
    },
    showAvatar: {
      objectFit: 'cover',
      width: 25,
      height: 25,
      borderRadius: '50%',
      borderColor: '#205373',
      borderWidth: 2,
      borderStyle: 'solid',
    },
    notAvatar: {
      objectFit: 'contain',
      width: '100%',
      height: '100%',
      maxHeight: 25,
      cursor: 'pointer',
    },
    locationAlertContainer: {
      top: '-140px !important',
      right: '-40px !important',
      padding: '15px !important',
      borderRadius: '5px !important',
      width: '329px !important',
      transform: 'initial !important',
      [theme.breakpoints.down(600)]: {
        width: '250px !important',
      },
      [theme.breakpoints.down(440)]: {
        right: '-70px !important',
      },
    },
    notCheckedOnLocation: {
      position: 'absolute',
      right: '-100%',
      top: 0,
      borderRadius: 8,
      width: 16,
      height: 16,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: '#fba050',
      [theme.breakpoints.down('md')]: {
        right: -17,
      },
    },
    checkedOnLocation: {
      display: 'flex',
      borderRadius: 8,
      justifyContent: 'center',
      alignItems: 'center',
      position: 'absolute',
      backgroundColor: '#c0ccc1',
      right: '-100%',
      top: 0,
      width: 16,
      height: 16,
      // [theme.breakpoints.up('md')]: {
      //   right: -17,
      //  // transform: 'translateX(110%)',
      // },
      [theme.breakpoints.down(920)]: {
        right: -17,
      },
    },
    cartLoc: {
      marginRight: 20,
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
      cursor: 'pointer',
      gap: 5,
    },
    btnLocation: {
      flex: 1,
      height: 40,
      textTransform: 'inherit',
      fontSize: 14,
      color: '#fff',
    },
    registerByRoleBtn: {
      flex: 1,
      height: 44,
      textTransform: 'inherit',
      fontSize: 14,
      color: '#fff',
      backgroundColor: '#7c97c0',
      borderRadius: 22,
    },
  };
});

type TProps = {
  showAvatar?: boolean;
};

const UserProfile: React.FC<TProps> = ({ showAvatar }) => {
  const intl = useIntl();
  const classes1 = useStyles();
  const { classes } = classes1;
  const { close: closeCategories } = useModalCategory();
  const dispatch = useDispatch();

  const { me, loading } = useSelector((store: IAppState) => ({
    me: store.profile.me,
    loading: store.profile.loading,
  }));

  const { isAuthorized } = useSelector((store: IAppState) => ({
    isAuthorized: store.auth.user != null,
  }));

  const { cartLenght, guestCartLenght } = useSelector((store: IAppState) => ({
    cartLenght: store.cart.cart?.items?.length,
    guestCartLenght: store.cart.guestCart?.items?.length,
  }));

  const isVendor = useDefineUserRole(me, ['ROLE_VENDOR']);
  const isVendorStaff = useDefineUserRole(me, ['ROLE_VENDOR_STAFF']);
  const isBuyer = useDefineUserRole(me, ['ROLE_BUYER']);
  const isBuyerStaff = useDefineUserRole(me, ['ROLE_BUYER_STAFF']);

  useEffect(() => {
    const localLocation = localStorage.getItem('location');
    const parseLocalLocation = localLocation && JSON.parse(localLocation);
    if (parseLocalLocation) {
      dispatch(setLocation(parseLocalLocation));
    }
  }, []);

  if (loading) return null;

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {(isBuyer || isBuyerStaff || !isAuthorized) && (
        <Link
          to={`/cart`}
          style={{ textDecoration: 'none' }}
          className={`kt-header__topbar-user kt-menu__link ${
            isAuthorized ? classes.cartBtn : classes.cartBtnGuest
          }`}
          onClick={closeCategories}
        >
          <img
            alt='Select file'
            className={`kt-menu__link-icon  kt-menu-cart-icon ${classes.iconStandardized}`}
            style={{ marginBottom: 2 }}
            src={toAbsoluteUrl('/images/basket-icon.svg')}
          />
          <div
            className={`kt-menu__link-text  ${classes.cartText}`}
            style={{ fontWeight: 700, textDecoration: 'none' }}
          >
            <FormattedMessage
              id='CART.SUBHEADER.TITLE'
              defaultMessage={'CART.SUBHEADER.TITLE'}
            />
          </div>
          {Boolean(isAuthorized) && cartLenght && cartLenght > 0 ? (
            <div className={classes.cartBadge}>
              <span className='kt-menu__link-badge'>
                <span
                  className={`kt-badge kt-badge--danger kt-badge--bolder kt-badge--inline kt-badge--pill`}
                >
                  {cartLenght}
                </span>
              </span>
            </div>
          ) : null}
          {!Boolean(isAuthorized) && guestCartLenght && guestCartLenght > 0 ? (
            <div className={classes.cartBadge}>
              <span className='kt-menu__link-badge'>
                <span
                  className={`kt-badge kt-badge--danger kt-badge--bolder kt-badge--inline kt-badge--pill`}
                >
                  {guestCartLenght}
                </span>
              </span>
            </div>
          ) : null}
        </Link>
      )}

      {isAuthorized ? (
        <Dropdown
          className='kt-header__topbar-item kt-header__topbar-item--user'
          drop='down'
          align='end'
        >
          <Dropdown.Toggle as={HeaderDropdownToggle} id='dropdown-toggle-user-profile'>
            <div
              className='kt-header__topbar-user kt-menu__link'
              style={{ cursor: 'pointer' }}
            >
              {showAvatar && (
                <div
                  className={`kt-user-card__avatar ${classes.profileAvatar}`}
                  style={{ gap: 5 }}
                >
                  <img
                    alt='Select file'
                    className={`kt-menu__link-icon  kt-menu-cart-icon ${classes.notAvatar}`}
                    style={{ maxHeight: 20 }}
                    src={toAbsoluteUrl(`/images/main-profile-icon2.svg`)}
                  />
                  <div
                    className={`kt-menu__link-text  ${classes.cartText}`}
                    style={{ fontWeight: 700, lineHeight: 1, textDecoration: 'none' }}
                  >
                    <FormattedMessage
                      id='SETTING.PROFILE.EDIT'
                      defaultMessage={'SETTING.PROFILE.EDIT'}
                    />
                  </div>
                </div>
              )}
            </div>
          </Dropdown.Toggle>
          <Dropdown.Menu
            style={{
              borderRadius: 22,
            }}
            className='dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-xl'
          >
            {/** ClassName should be 'dropdown-menu dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-xl' */}
            <div
              className='kt-user-card kt-user-card--skin-dark kt-notification-item-padding-x'
              style={{
                backgroundColor: `#e6e7e8`,

                borderTopLeftRadius: 22,
                borderTopRightRadius: 22,
              }}
            >
              <div className='kt-user-card__name' style={{ fontWeight: '700' }}>
                {me?.last_name || ''} {me?.first_name || ''} {me?.middle_name || ''}
              </div>
            </div>
            <div className='kt-notification'>
              <Link
                to='/settings/profile'
                className='kt-notification__item'
                style={{ textDecoration: 'none' }}
                onClick={closeCategories}
              >
                <div className='kt-notification__item-details'>
                  <div className='kt-notification__item-title'>
                    {intl.formatMessage({ id: 'SUBMENU.PROFILE' })}
                  </div>
                </div>
              </Link>
              {(isVendor || isBuyer || isVendorStaff || isBuyerStaff) && (
                <Link
                  to={
                    isVendor || isBuyer || isVendorStaff || isBuyerStaff
                      ? '/companies/list'
                      : `/companies/edit/${me?.company?.id?.toString()}`
                  }
                  className='kt-notification__item'
                  style={{ textDecoration: 'none' }}
                  onClick={closeCategories}
                >
                  <div className='kt-notification__item-details'>
                    <div className='kt-notification__item-title'>
                      {intl.formatMessage({ id: 'MENU.MY_COMPANY' })}
                    </div>
                  </div>
                </Link>
              )}
              {(isBuyer || isBuyerStaff) && (
                <Link
                  to='/orders/list/full'
                  className='kt-notification__item'
                  style={{ textDecoration: 'none' }}
                  onClick={closeCategories}
                >
                  <div className='kt-notification__item-details'>
                    <div className='kt-notification__item-title'>
                      {intl.formatMessage({ id: 'MENU.MY_ORDERS' })}
                    </div>
                  </div>
                </Link>
              )}

              <div className='kt-notification__custom'>
                <Link
                  to='/logout'
                  onClick={closeCategories}
                  className='btn btn-label-brand btn-sm'
                  style={{
                    fontWeight: 'normal',
                    width: '100%',
                    backgroundColor: '#d01c1f',
                    color: '#fff',
                    textDecoration: 'none',
                  }}
                >
                  {intl.formatMessage({ id: 'SUBMENU.EXIT' })}
                </Link>
              </div>
            </div>
          </Dropdown.Menu>
        </Dropdown>
      ) : (
        <Link
          style={{
            height: 55,
            justifyContent: 'space-evenly',
            textDecoration: 'none',
          }}
          to='/auth'
          onClick={closeCategories}
          className={`${
            isAuthorized ? 'kt-login__signup' : 'kt-header__topbar-user kt-menu__link'
          } ${classes.auth}`}
        >
          <img
            alt='Select file'
            className={`kt-menu__link-icon  kt-menu-cart-icon ${classes.iconStandardized}`}
            src={toAbsoluteUrl(
              isAuthorized
                ? '/images/main-profile-icon-auth.svg'
                : '/images/main-profile-icon2.svg'
            )}
          />
          <span
            className={`kt-menu__link-text  ${classes.cartText}`}
            style={{ fontWeight: 700, textDecoration: 'none' }}
          >
            <FormattedMessage id='SUBMENU.AUTHORIZE' defaultMessage={'SUBMENU.AUTHORIZE'} />
          </span>
        </Link>
      )}
    </div>
  );
};

export default UserProfile;
